/** The look every grid of the entry form shares, so the tabs read as one screen. */
export const gridHeadSx = { bgcolor: "background.default" };
export const gridHeadCellSx = { whiteSpace: "nowrap", fontWeight: 600 };
